// 🎯 Adaptador de API para el detalle de órdenes de ubicación - API adapter for location order details
import { HttpClient } from '@shared/adapters/HttpClient';
import { LocationOrderModel, ReceiveReturnedResponse } from '../models';

export class ReceiveApiAdapter {
  constructor(private httpClient: HttpClient) {}

  // 🎯 Obtener datos de la orden de ubicación por ID
  async getLocationOrderById(id: number): Promise<LocationOrderModel> {
    try {
      const response = await this.httpClient.get<LocationOrderModel>(`/location-orders/${id}`);
      return response;
    } catch (error: any) {
      console.log('🔍 ReceiveApiAdapter - Error:', {
        message: error.message,
        response: error.response,
      });
      throw error;
    }
  }

  // 🎯 Recepcionar líneas de la orden
  async receiveLocationOrderLines(
    id: number,
    data: {
      order_id: number;
      lines: Array<{ product_id: number; quantity: number }>;
    },
  ): Promise<ReceiveReturnedResponse> {
    try {
      const response = await this.httpClient.post<ReceiveReturnedResponse>(`/location-orders/${id}/receive`, data);
      return response;
    } catch (error: any) {
      console.log('🔍 ReceiveApiAdapter - Error en recepción:', {
        message: error.message,
        response: error.response,
      });
      throw error;
    }
  }

  // 🎯 Ubicar un producto en una ubicación (registrar movimiento)
  async locateProduct(
    id: number,
    data: {
      product_id: number;
      qty: number;
      to_location_id: number;
      batch_id?: number;
    },
  ): Promise<ReceiveReturnedResponse> {
    try {
      const response = await this.httpClient.put<ReceiveReturnedResponse>(`/location-orders/${id}/locate`, data);
      return response;
    } catch (error: any) {
      console.log('🔍 ReceiveApiAdapter - Error en ubicación:', {
        message: error.message,
        response: error.response,
      });
      throw error;
    }
  }

  // 🎯 Asignar carrito a una orden de ubicación
  async assignCartToOrder(id: number, data: { cart_code: string }): Promise<ReceiveReturnedResponse> {
    try {
      const response = await this.httpClient.post<ReceiveReturnedResponse>(`/location-orders/${id}/cart`, data);
      return response;
    } catch (error: any) {
      console.log('🔍 ReceiveApiAdapter - Error al asignar carrito:', {
        message: error.message,
        response: error.response,
      });
      throw error;
    }
  }

  // 🎯 Finalizar una orden de ubicación
  async finalizeLocationOrder(id: number): Promise<ReceiveReturnedResponse> {
    try {
      const response = await this.httpClient.put<ReceiveReturnedResponse>(`/location-orders/${id}/finalize`, {});
      return response;
    } catch (error: any) {
      console.log('🔍 ReceiveApiAdapter - Error al finalizar:', {
        message: error.message,
        response: error.response,
      });
      throw error;
    }
  }
}
